module.exports = __webpack_public_path__ + "media/2ND_2023.03547435.mp4";